module.exports = __webpack_public_path__ + "media/images/hitfun/sample.contestpic.394x699-2d134c329f360754902ea4c9533af920.jpg";